<template>
  <v-container fluid>
    <v-text-field
      name="search"
      label="Start typing to Search (3 or more letters)"
      prepend-icon="search"
      v-model="search"
      clearable
    ></v-text-field>
    <!-- <v-autocomplete
      :filter="filterLocations"
      :items="searchData.locations"
      :loading="searchData.loading"
      :search-input.sync="search"
      item-text="display_name"
      item-value="id"
      label="Search Locations"
      prepend-icon="search"
      placeholder="Start typing to Search (3 or more letters)"
      clearable
      @change="locationFound"
    >
      <template v-slot:item="data">
        <v-list-item-content>
          <v-list-item-title v-html="data.item.display_name"></v-list-item-title>
          <v-list-item-subtitle v-html="data.item.address.formatted_address"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>-->
    <v-data-table items-per-page="25" hide-default-footer class="background" :headers="headers" :items="filteredLocations">
      <template v-slot:[`item.is_corporate`]="{ item }">
        <v-switch inset disabled v-model="item.is_corporate"></v-switch>
      </template>
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip top dark>
          <template v-slot:activator="{ on }">
            <v-btn
              elevation="0"
              slot="activator"
              fab
              small
              dark
              v-on="on"
              @click="goToProfile(item)"
              color="primary"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-3 xs-small' : 'ml-3 xs-small'"
            >
              <v-icon small>fas fa-cog</v-icon>
            </v-btn>
          </template>
          <span>Settings</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-pagination
      v-if="search.length < 3"
      class="mb-10"
      @input="goToPage"
      @next="nextPage"
      @previous="previousPage"
      total-visible="6"
      v-model="pagination.page"
      :length="pagination.pageCount"
    ></v-pagination>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>Create a location</v-card-title>
        <v-card-subtitle>Create a new location in just a few steps</v-card-subtitle>
        <v-card-text>
          <v-text-field v-model="newLocation.name" label="Name"></v-text-field>
          <v-text-field v-model="newLocation.display_name" label="Display Name"></v-text-field>
          <v-text-field v-model="newLocation.slug" label="Slug"></v-text-field>
          <v-text-field v-model="newLocation.internal_id" label="Internal ID"></v-text-field>
          <v-switch v-model="newLocation.is_corporate" label="Corporate"></v-switch>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="grey" text class="text-capitalize">Cancel</v-btn>
          <v-btn @click="createNewLocation" color="primary" class="text-capitalize">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn @click="dialog = true" fab fixed dark bottom right color="primary" v-on="on">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <span>Create Location</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import { LocationAPI } from '@/clients/locations/locations.api'
import { EventBus } from '@/event-bus'
import { debounce } from 'debounce'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      search: '',
      searchData: {
        locations: [],
        loading: false
      },
      headers: [
        {
          text: 'Name',
          value: 'display_name'
        },
        {
          text: 'Address',
          value: 'address.formatted_address'
        },
        {
          text: 'Corporate',
          value: 'is_corporate',
          sortable: false
        },
        {
          text: 'Edit',
          value: 'edit',
          sortable: false
        }
      ],
      pagination: {
        itemsPerPage: 25,
        page: 1,
        pageCount: 0,
        pageStart: 0,
        pageStop: 0
      },
      totalLocations: 0,
      locations: [],
      newLocation: {
        name: '',
        display_name: '',
        slug: '',
        internal_id: '',
        is_corporate: false
      },
      dialog: false
    }
  },
  async mounted() {
    this.pageLoading = true
    await this.fetchLocations(this.pagination.page, this.pagination.itemsPerPage)
    EventBus.$on('fetch-mounting-methods', async () => {
      this.pageLoading = true
      await this.fetchLocations(this.pagination.page, this.pagination.itemsPerPage)
      this.pageLoading = false
    })
    this.pageLoading = false
  },
  methods: {
    ...mapMutations({
      vm_setLocation: 'locations/SET_SELECTED_LOCATION'
    }),
    async fetchLocations(page, limit) {
      let response
      try {
        response = await LocationAPI.getAllLocations(page, limit)
      } catch (error) {
        this.locations = []
        return
      }
      this.locations = response.data.payload.locations
      this.totalLocations = response.data.payload.total
      this.pagination.pageCount = response.data.payload.total_pages
    },
    fetchPagedListBack() {
      this.pagination.page -= 1
      this.fetchLocations()
    },
    fetchPagedList(page) {
      if (this.pagination.page !== page) {
        this.pagination.page = page
        this.fetchLocations()
      }
    },
    fetchPagedListForward() {
      this.pagination.page += 1
      this.fetchLocations()
    },

    goToPage(page) {
      this.fetchLocations(page, this.pagination.itemsPerPage)
    },
    nextPage() {
      if (this.pagination.page < this.pagination.length) {
        this.goToPage(this.pagination.page)
      }
    },
    previousPage() {
      if (this.pagination.page >= 1) {
        this.goToPage(this.pagination.page)
      }
    },
    goToProfile(location) {
      this.vm_setLocation(location)
      this.$router.push({ name: 'Profile_Store_Information', params: { id: location.id } })
    },
    goToProfileAddress(location) {
      this.$router.push({ name: 'Profile_Store_Address', params: { id: location.id } })
    },
    async createNewLocation() {
      let response
      try {
        response = await LocationAPI.createLocation(this.newLocation)
      } catch (error) {
        return console.log(error)
      }
      this.goToProfileAddress(response.data.payload)
      this.swal({ title: 'Success', text: 'NEW Location successfully created.', timer: 3000 })
    },
    async searchLocations(term) {
      this.searchData.loading = true
      let response
      try {
        response = await LocationAPI.searchLocations(term.toLowerCase())
      } catch (error) {
        this.searchData.locations = []
        this.searchData.loading = false
        return
      }
      this.searchData.locations = response.data.payload
      this.searchData.loading = false
    }
  },
  watch: {
    search: {
      handler: function (value) {
        if (!value || value.length < 3) {
          this.searchData.locations = []
          return
        }
        debounce(this.searchLocations, 200)(value, this)
      }
    }
  },
  computed: {
    filteredLocations() {
      if (this.search.length < 3) {
        return this.locations
      } else {
        return this.searchData.locations
      }
    }
  }
}
</script>

<style>
</style>
